/* HADARA · FILTER HELPERS
   Set-logic used by the catalogue: OR within a facet group, AND across groups. */
window.HadaraFilters = {
  matches: function (itemTags, selection) {
    for (var facet in selection) {
      var vals = selection[facet];
      if (!vals.length) continue;
      var hit = false;
      for (var i = 0; i < vals.length; i++) { if (itemTags.indexOf(vals[i]) !== -1) { hit = true; break; } }
      if (!hit) return false;
    }
    return true;
  },
  countFor: function (items, tag, selection, exceptFacet) {
    var probe = {};
    for (var k in selection) if (k !== exceptFacet) probe[k] = selection[k];
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].indexOf(tag) !== -1 && this.matches(items[i], probe)) n++;
    }
    return n;
  }
};
